import { forwardRef, createElement } from 'react';

function IconQuicklinks(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M7.102 11.125c.753 0 1.472.295 2.007.817l.142.148 4.806 5.407c.183.206.434.337.705.37l.136.008h3.416L17.22 16.78l-.073-.084a.75.75 0 011.05-1.049l.083.073 2.5 2.5a.753.753 0 01.097.118l.053.094.028.07.023.08.013.075.006.102-.002.042-.009.075-.027.111-.043.102-.038.066-.027.04-.035.043-.039.042-2.5 2.5-.084.073a.75.75 0 01-1.049-1.05l.073-.083 1.095-1.096-3.417.001a2.875 2.875 0 01-2.007-.817l-.142-.148-4.806-5.407a1.125 1.125 0 00-.705-.37l-.136-.008H3.75a.875.875 0 01-.11-1.743l.11-.007h3.352zm11.094-8.978l.084.073 2.5 2.5a.63.63 0 01.101.125l.049.088.043.119.021.106.004.042.002.069-.006.073-.013.076-.023.08-.047.107-.058.091-.073.084-2.5 2.5a.75.75 0 01-1.133-.976l.073-.084 1.095-1.096-3.426.001-.136.008c-.223.027-.433.12-.603.268l-.096.095-2.905 3.215-.085.083a.875.875 0 01-1.287-1.162l.074-.094 2.904-3.215.141-.146a2.875 2.875 0 011.79-.795l.203-.007 3.424-.001L17.22 3.28a.75.75 0 01.976-1.133z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Quicklinks = /*#__PURE__*/forwardRef(IconQuicklinks);

export default Quicklinks;
//# sourceMappingURL=Quicklinks.js.map
